export default {
  list: {
    pageTitle: 'Workflow Management',
    totalRecords: 'Total {count} records',
    search: {
      name: 'Workflow Name',
      office: 'Office',
      form: 'Bound Form',
      status: 'Status',
      createdAt: 'Created Time',
      namePlaceholder: 'Enter workflow name',
      officePlaceholder: 'Select office',
      formPlaceholder: 'Select bound form',
      statusPlaceholder: 'Select status',
      createdAtPlaceholder: 'Select created time'
    },
    table: {
      index: 'No.',
      name: 'Workflow Name',
      form: 'Bound Form',
      office: 'Office',
      status: 'Status',
      remark: 'Remark',
      creator: 'Creator',
      modifier: 'Modifier',
      createdAt: 'Created Time',
      updatedAt: 'Updated Time',
      operations: 'Operations',
      noOffice: 'All',
      unknownForm: 'Scene {id}'
    },
    actions: {
      create: 'Create Workflow',
      delegation: 'Delegation Config',
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      enable: 'Enable',
      disable: 'Disable'
    },
    confirm: {
      enable: 'Enable this workflow?',
      disable: 'Disable this workflow?',
      delete: 'Delete this workflow?'
    },
    messages: {
      copied: 'Workflow copied successfully',
      deleted: 'Workflow deleted successfully',
      enabled: 'Workflow enabled successfully',
      disabled: 'Workflow disabled successfully',
      loaded: 'Workflow data loaded successfully'
    }
  },
  delegation: {
    title: 'Delegation Config',
    table: {
      index: 'No.',
      approver: 'Approver',
      delegatee: 'Delegatee',
      operations: 'Operations'
    },
    placeholders: {
      approver: 'Select approver',
      delegatee: 'Select delegatee'
    },
    actions: {
      addRow: 'Add Row'
    },
    messages: {
      approverRequired: 'Select an approver',
      delegateeRequired: 'Select a delegatee',
      duplicateApprover: 'Approver cannot be duplicated',
      crossDuplicate: 'Approver and delegatee cannot be configured repeatedly or crosswise',
      saved: 'Delegation config saved'
    }
  },
  editor: {
    createTitle: 'Create Workflow',
    editTitle: 'Edit Workflow',
    canvasTitle: 'Workflow Designer',
    basicInfo: 'Basic Info',
    nodeSettings: 'Node Settings',
    branchLimit: 'Max branches: {count}',
    selectedNode: 'Selected node: {name}',
    noNodeSelected: 'Select a node on the canvas to configure it',
    noRuleDefinition: 'No condition fields are available for the selected bound form',
    form: {
      name: 'Process Name',
      office: 'Office',
      form: 'Bound Form',
      canUndo: 'Can Undo',
      unknownProcessHandleMode: 'Unknown Process Mode',
      quickApprovalMode: 'Same Approver Handling Across Different Nodes',
      needConfirmPopupOnInitiate: 'Confirm Popup on Initiate',
      autoWriteOffAfterApproval: 'Whether to Auto Write-off After Approval',
      invoicingMode: 'Invoicing Mode',
      templatePush: 'Template Push',
      notifications: 'Notification Method',
      remark: 'Remark',
      namePlaceholder: 'Please enter process name',
      officePlaceholder: 'Please select office',
      formPlaceholder: 'Please select bound form',
      remarkPlaceholder: 'Please enter remark',
      branchLimitPlaceholder: 'Auto calculated after selecting office and form',
      autoWriteOffHelp: 'Legacy-compatible field, currently passed through according to backend capability',
      templatePlaceholder: 'Please select template',
      exportTypePlaceholder: 'Please select export type'
    },
    tabs: {
      process: 'Process',
      node: 'Node'
    },
    enums: {
      canUndo: {
        allowed: 'Allowed',
        notAllowed: 'Not Allowed'
      },
      autoWriteOff: {
        none: 'No Write-off',
        original: 'Auto Write-off'
      },
      formSubtype: {
        makeInvoiceBilling: 'Bill application',
        makeInvoiceInternalInvoice: 'Internal invoice application',
        collectInvoiceInternalInvoice: 'Internal invoice application'
      },
      businessScene: {
        billPayment: 'Bill payment',
        makeInvoice: 'Make invoice',
        jobCharge: 'Job charge',
        tempCredit: 'Temp credit',
        chargeChange: 'Charge change',
        collectInvoice: 'Collect invoice',
        partnerApplicationForm: 'Partner Application Form',
        contractApplicationForm: 'Contract Application Form',
        advPaymentRefundForm: 'Refund of Advanced Payment Application Form'
      },
      status: {
        enabled: 'Enabled',
        disabled: 'Disabled',
        hiddenDisabled: 'Hidden Disabled'
      },
      notifications: {
        email: 'Email',
        bell: 'Bell',
        weixin: 'Wechat',
        enterpriseWechat: 'DingTalk'
      },
      actorType: {
        role: 'Role',
        user: 'User',
        parent: 'Parent',
        position: 'Position'
      },
      nodeType: {
        single: 'Single Approval',
        all: 'All Approval'
      },
      branchRuleMode: {
        none: 'No Condition',
        any: 'Any Match',
        all: 'All Match'
      },
      unknownProcessHandleMode: {
        pass: 'Proceed to the next step directly when no match',
        reject: 'Show an exception prompt when no match'
      },
      quickApprovalMode: {
        firstNode: 'After the first node is processed, the rest automatically agree',
        continuousNode: 'Automatically agree only for continuous handling',
        everyNode: 'Each node task needs to be processed'
      },
      cancelAllowed: {
        previous: 'Return to Previous',
        initiator: 'Return to Initiator'
      },
      relation: {
        and: 'AND',
        or: 'OR'
      }
    },
    branch: {
      main: 'Main Flow',
      branch: 'Branch {index}',
      addBranch: 'Add Branch',
      addNode: 'Add Node',
      deleteBranch: 'Delete Branch',
      ruleSummary: 'Trigger Rules',
      noRule: 'No Conditions',
      allRule: 'All Match',
      anyRule: 'Any Match',
      deleteConfirm: 'Delete this branch?'
    },
    node: {
      unnamed: 'Unnamed Node',
      name: 'Node Name',
      type: 'Approval Mode',
      actorType: 'Approver Type',
      actorId: 'Approver',
      notifierType: 'Notifier Type',
      notifierId: 'Notifier',
      editable: 'Allow Editing',
      remarkRequired: 'Remark Required',
      cancelAllowed: 'Reject Mode',
      transferAllowed: 'Allow Transfer',
      dashboardName: 'Dashboard Name',
      dashboardId: 'Dashboard ID',
      preCriteria: 'Pre-criteria',
      namePlaceholder: 'Enter node name',
      actorPlaceholder: 'Select approver',
      notifierPlaceholder: 'Select notifier',
      positionPlaceholder: 'Enter position IDs',
      dashboardNamePlaceholder: 'Enter dashboard name',
      dashboardIdPlaceholder: 'Enter dashboard ID',
      parentHint: 'Parent approvers are resolved automatically from the initiator hierarchy. A system placeholder is used on save.',
      positionHint: 'Position dropdown is not integrated yet. Configure by position IDs for now.'
    },
    condition: {
      title: 'Condition Configuration',
      branchTitle: 'Branch Trigger Conditions',
      preTitle: 'Node Pre-criteria',
      relation: 'Relation',
      field: 'Field',
      operator: 'Operator',
      value: 'Value',
      sequence: 'No.',
      operation: 'Operation',
      add: 'Add Condition',
      delete: 'Delete Condition',
      deleteSelected: 'Delete',
      empty: 'No conditions',
      valuePlaceholder: 'Enter value',
      fieldPlaceholder: 'Select field',
      operatorPlaceholder: 'Select operator',
      valueSelectPlaceholder: 'Select value'
    },
    actions: {
      save: 'Save',
      cancel: 'Cancel',
      backToList: 'Back to List'
    },
    messages: {
      loaded: 'Workflow detail loaded successfully',
      saved: 'Workflow saved successfully',
      rulesLoaded: 'Condition fields loaded successfully',
      branchLimitLoaded: 'Branch limit updated',
      formRequired: 'Select a bound form first',
      formSubtypeRequired: 'Select an invoicing mode',
      exportTypeRequired: 'Select an export type for the template',
      officeRequired: 'Select offices first',
      nameRequired: 'Enter the workflow name',
      branchRequired: 'Keep at least one branch',
      nodeRequired: 'Each branch must contain at least one approval node',
      nodeNameRequired: 'Enter the node name',
      actorTypeRequired: 'Select an approver type',
      actorRequired: 'Complete the approver configuration',
      notifierRequired: 'Complete the notifier configuration',
      ruleRequired: 'Complete branch trigger conditions',
      duplicateRule: 'Duplicate branch trigger conditions exist',
      preCriteriaRequired: 'Complete node pre-criteria',
      branchLimitExceeded: 'The branch limit {count} has been reached',
      deleteNodeConfirm: 'Delete this node?',
      formOptionsLoading: 'Loading available forms',
      branchLimitUnavailable: 'Branch limit is unavailable. Confirm platform config with the backend service.'
    }
  }
}
